<template>
  <div>
    <!-- 轮播图 -->
    <div class="block">
      <el-carousel height="550px">
        <!-- <el-carousel-item v-for="item in 4" :key="item">
          <h3 class="small">{{ item }}</h3>
        </el-carousel-item> -->
        <el-carousel-item>
          <img src="../../image/home/BANNER_1@2x.png" alt="" />
          <div class="tiyan" @click="goBto">立即体验</div>
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../image/home/BANNER_1@2x.png" alt="" />
          <div class="tiyan" @click="goBto">立即体验</div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 轮播图 end------------------->

    <div class="row6">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">多场景满意度测评 满足您不同的业务需求</div>
        <br />
        <div class="t2">助您洞察市场的真实情况</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="b1">
          <div class="t1">“</div>
          <div class="t2">
            这是一个最好的时代；<br />
            也是一个最坏的时代。<br />
            在无奈的新常态下，<br />
            我们的生活还要继续，<br />
            但是我们的债务从来不会停止，<br />
            如何在特殊时期处理债务我们最专业。
          </div>
          <div class="t3">欢迎加入我们</div>
        </div>

        <div class="b2">
          <img src="@/image/home/tu15@2x.png" alt="" />
        </div>
      </div>
    </div>
    <div class="row5">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">多场景满意度测评 满足您不同的业务需求</div>
        <br />
        <div class="t2">助您洞察市场的真实情况</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu3@2x.png" alt="" />
          </div>

          <div class="text1">企业</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu4@2x.png" alt="" />
          </div>

          <div class="text1">零售</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu5@2x.png" alt="" />
          </div>

          <div class="text1">母婴</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu6@2x.png" alt="" />
          </div>

          <div class="text1">超市</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu7@2x.png" alt="" />
          </div>

          <div class="text1">餐饮</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu8@2x.png" alt="" />
          </div>

          <div class="text1">酒店</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu9@2x.png" alt="" />
          </div>

          <div class="text1">景区</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu10@2x.png" alt="" />
          </div>

          <div class="text1">教育</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu11@2x.png" alt="" />
          </div>

          <div class="text1">医疗</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu12@2x.png" alt="" />
          </div>

          <div class="text1">政务</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu13@2x.png" alt="" />
          </div>

          <div class="text1">金融</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu14@2x.png" alt="" />
          </div>

          <div class="text1">娱乐</div>

          <div class="line"></div>
        </div>
      </div>
    </div>

    <div class="row1"></div>
  </div>
</template>

<script>
export default {
  name: 'DczxxIndex',

  data() {
    return {}
  },

  mounted() {},

  methods: {
    //到底
    goBto() {
      document.getElementById('bot').scrollIntoView(true)
    },
  },
}
</script>

<style lang="scss" scoped>
//轮播图
.block {
  width: 100%;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .tiyan {
    margin-left: 2px;
    width: 120px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    background-color: #4581fb;
    border-radius: 4px;
    position: absolute;
    left: 21%;
    bottom: 28%;
  }

  /deep/ .el-carousel__button {
    // 默认按钮的颜色大小等
    width: 36px;
    height: 4px;
    border: none;
    border-radius: 20px;
    background: #ffffff;
    opacity: 1;
  }

  /deep/ .is-active .el-carousel__button {
    // 选中图片的颜色
    background: #14a5fe;
    opacity: 1;
  }
}

.row1 {
  height: 395px;
  width: 100%;
  background-image: url(@/image/test/xia.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.row2 {
  height: 690px;
  overflow: hidden;

  background-color: #f7f8fb;
  position: relative;

  .title {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 90px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    display: flex;

    width: 1300px;
    margin: 150px auto;
    justify-content: space-around;

    .r2-tiem {
      background-color: #ffffff;
      height: 160px;
      width: 260px;
      position: relative;
      border-radius: 6px;

      img {
        margin-top: 15px;
        height: 24px;
        width: 120px;
      }
      .t1 {
        overflow: hidden;
        width: 45%;
        font-size: 38px;
        font-weight: 600;
        margin: 20px auto;
        text-align: center;
      }
      .t2 {
        margin: 100px auto 0 auto;
        text-align: center;
      }
    }
  }

  .zixun {
    letter-spacing: 1px;
    // position: absolute;
    bottom: 100px;
    width: 170px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    color: #fff;
    border-radius: 2px;
    margin: 180px auto;
  }
}

.row3 {
  height: 650px;

  position: relative;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 65px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 650px;

    margin: 120px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item1 {
      width: 280px;
      height: 320px;
      // border: 1px solid;
      margin-right: 40px;
      box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        width: 90px;
        height: 85px;
        margin: 45px auto 18px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .text1 {
        width: 250px;
        text-align: center;
        margin: 30px auto 16px auto;
        font-size: 18px;
        letter-spacing: 2px;
      }

      .text2 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 2px auto;
        font-size: 15px;
        color: #999999;
      }
      .text3 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 10px auto;
        font-size: 15px;
        color: #999999;
      }
    }
    .item1:hover {
      transform: translate(0, -8px);
      transition-duration: 0.2s;
      color: #4581fb;
      transition-timing-function: linear;
    }
  }
}

.row4 {
  height: 800px;
  background-color: #313131;
  position: relative;
  overflow: hidden;

  .title {
    margin-top: 40px;
    display: flex;
    color: #ffffff;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 95px;
      color: #ffffff;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 380px;

    margin: 150px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item1 {
      width: 380px;
      height: 120px;
      background-color: #404040;
      // border: 1px solid;
      display: flex;
      // justify-content: center;

      align-items: center;
      margin-right: 60px;
      // box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        width: 64px;
        height: 64px;
        margin-left: 35px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .text1 {
        width: 200px;
        text-align: center;
        color: #ffffff;
        font-size: 18px;
        letter-spacing: 2px;
      }
    }
  }

  .zixun {
    letter-spacing: 1px;
    position: absolute;
    bottom: 100px;
    width: 170px;
    left: 850px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border: 1px solid #ffffff;
    color: #fff;
    border-radius: 2px;
  }
}

.row5 {
  height: 870px;
  overflow: hidden;
  position: relative;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 115px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1700px;
    height: 650px;

    margin: 80px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item1 {
      width: 200px;
      height: 210px;
      position: relative;
      // border: 1px solid;
      margin-right: 30px;
      box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        position: absolute;
        top: 0;
        width: 200px;
        height: 210px;
        z-index: -100;

        img {
          background-color: #000;
          opacity: 2;
          width: 100%;
          height: 100%;
        }
      }
      .img::after {
        content: ' ';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: 0.3;
      }

      .text1 {
        width: 200px;
        text-align: center;
        margin: 140px auto 16px auto;
        color: #ffffff;
        font-size: 22px;
        text-align: center;
        letter-spacing: 2px;
      }
      .line {
        background-color: #ffffff;

        height: 2px;
        width: 40px;
        margin: 10px auto;
      }
    }
    .item1:hover {
      transform: translate(0, -8px);
      transition-duration: 0.2s;

      transition-timing-function: linear;
    }
  }
}

.row6 {
  height: 860px;
  overflow: hidden;
  position: relative;
  background-color: #f7f8fb;
  margin-bottom: 30px;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 115px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1400px;
    height: 500px;
    margin: 100px auto 0 auto;
    box-sizing: border-box;

    .b1 {
      width: 50%;
      background-color: #ffffff;

      position: relative;

      .t1 {
        font-size: 120px;
        position: absolute;
        top: 60px;

        color: #4581fb;
      }

      .t2 {
        position: absolute;
        letter-spacing: 1px;
        line-height: 30px;
        font-size: 18px;
        left: 180px;
        top: 120px;
        color: #333333;
      }

      .t3 {
        color: #4581fb;
        position: absolute;
        bottom: 90px;
        font-size: 33px;
        left: 220px;
      }
    }

    .b2 {
      width: 50%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
